import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Observable} from "rxjs";
import {LogementService} from "../../services/logement.service";
import {Contact} from "../../models/contact";
import {ContactService} from "../../services/contact.service";
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastService} from "../../services/toast.service";
import {Logement} from "../../models/logement";
import {UserService} from "../../services/user.service";

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContactsComponent implements OnInit {

  faPlus = faPlus;

  logement$: Observable<Logement> = null;
  contacts$: Observable<Contact[]>;

  constructor(private logementService: LogementService,
              public contactService: ContactService,
              public modalService: NgbModal,
              public userService: UserService,
              private toastService: ToastService) {
  }

  ngOnInit() {
    this.logement$ = this.logementService.logementCourant;
    this.contacts$ = this.contactService.contacts;
    const logementId = this.logementService.getLogementCourantId();
    this.contactService.load(logementId);
  }

  delete(contact) {
    const logementId = this.logementService.getLogementCourantId();
    this.contactService.delete(logementId, contact.id).then(data => {
      this.contactService.load(logementId);
      this.toastService.show(data.message, {classname: 'toast-' + data.status});
    });
  }

  openToLocataires(contact) {
    const logementId = this.logementService.getLogementCourantId();
    this.contactService.openToLocataires(logementId, contact.id).then(data => {
      this.contactService.load(logementId);
      this.toastService.show(data.message, {classname: 'toast-' + data.status});
    });
  }

  closeToLocataires(contact) {
    const logementId = this.logementService.getLogementCourantId();
    this.contactService.closeToLocataires(logementId, contact.id).then(data => {
      this.contactService.load(logementId);
      this.toastService.show(data.message, {classname: 'toast-' + data.status});
    });
  }
}
